import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import MaterialTable, { MTableToolbar } from "material-table";
import FormControl from "@material-ui/core/FormControl";
import Input from "@material-ui/core/Input";
import Grid from "@material-ui/core/Grid";
import InputAdornment from "@material-ui/core/InputAdornment";
import Search from "@material-ui/icons/Search";

import useDebounce from "../global/use-debounce";
import { getPaginateUnapprovedPromos } from "../../actions/admin/unapproved_promo";

const List = ({ getPaginateUnapprovedPromos }) => {
    const table = useRef();

    const [pageSize, setPageSize] = useState(5);

    const initializeFocusValue = {
        searchFocus: false
    };

    const [autoFocus, setAutoFocus] = useState(initializeFocusValue);

    const [search, setSearch] = useState("");

    const debouncedSearch = useDebounce(search, 500);

    const { searchFocus } = autoFocus;

    const columns = [
        { title: "ID", field: "id", defaultSort: "asc" },
        { title: "Title", field: "title" },
        {
            title: "Description",
            field: "description",
            cellStyle: {
                width: "40%"
            }
        },
        { title: "Source", field: "source" },
        // {
        //     title: "Date From",
        //     field: "dateFrom",
        //     filtering: false,
        //     render: rowData => moment(rowData.dateFrom).format("DD-MM-YYYY HH:mm")
        // },
        // {
        //     title: "Date Till",
        //     field: "dateTill",
        //     filtering: false,
        //     render: rowData => {
        //         return moment(rowData.dateTill).format("DD-MM-YYYY HH:mm");
        //     }
        // }
    ];

    useEffect(() => {
        getPaginateUnapprovedPromos();
    }, [getPaginateUnapprovedPromos]);

    useEffect(() => {
        table.current && table.current.onQueryChange();
    }, [debouncedSearch]);

    const handleSearchChange = e => {
        setSearch(e.target.value);

        setAutoFocus({ ...autoFocus, searchFocus: true });
    };

    return (
        <MaterialTable
            tableRef={table}
            className={"material-table"}
            title="Unapproved Promo List"
            columns={columns}
            onChangeRowsPerPage={pageSize => {
                setAutoFocus(initializeFocusValue);
                setPageSize(pageSize);
            }}
            data={query =>
                new Promise(async (resolve, reject) => {
                    try {
                        query.search = search;

                        const result = await getPaginateUnapprovedPromos(query);

                        let {
                            unapprovedPromos,
                            totalUnapprovedPromos
                        } = result;
                        let page = query.page;

                        if (unapprovedPromos.length === 0) {
                            page = 0;

                            if (totalUnapprovedPromos !== 0) {
                                const resultFirstPage = await getPaginateUnapprovedPromos(
                                    { ...query, page }
                                );

                                unapprovedPromos =
                                    resultFirstPage.unapprovedPromos;
                            }
                        }

                        resolve({
                            data: unapprovedPromos,
                            page: page,
                            totalCount: totalUnapprovedPromos
                        });
                    } catch (err) {
                        resolve({
                            data: [],
                            page: 0,
                            totalCount: 0
                        });
                    }
                })
            }
            options={{
                actionsColumnIndex: -1,
                pageSize,
                emptyRowsWhenPaging: false,
                search: false
            }}
            components={{
                Toolbar: props => (
                    <div>
                        <MTableToolbar {...props} />
                        <Grid container>
                            <Grid item sm={9}></Grid>
                            <Grid
                                item
                                container
                                spacing={1}
                                sm={3}
                                alignItems="center"
                                justify="center"
                            >
                                <Grid item xs={9}>
                                    <FormControl className="mb-2" fullWidth>
                                        <Input
                                            id="standard-adornment-amount"
                                            placeholder={"Search"}
                                            value={search}
                                            onChange={handleSearchChange}
                                            type="search"
                                            startAdornment={
                                                <InputAdornment position="start">
                                                    <Search />
                                                </InputAdornment>
                                            }
                                            autoFocus={searchFocus}
                                        />
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </Grid>
                    </div>
                )
            }}
        />
    );
};

List.postTypes = {
    getPaginateUnapprovedPromos: PropTypes.func.isRequired
};

export default connect(null, {
    getPaginateUnapprovedPromos
})(List);
